/**
 * sanitizeHtml.js — shared draft-HTML sanitizer for the client.
 *
 * One policy used by EVERY `dangerouslySetInnerHTML` sink that renders draft /
 * document HTML: the two draft modals, the admin OrderDetail view, the minutes
 * page, and the report preview. Keeping a single source of policy means a draft
 * is sanitized identically wherever it is shown.
 *
 * Statutory documents are text + tables — they never need <img>, scripts, forms,
 * or event handlers, so those are dropped while the inline styles and table
 * markup the renderers rely on are preserved.
 */
import DOMPurify from 'dompurify';

const CONFIG = {
  USE_PROFILES: { html: true },
  // <img> dropped on purpose: statutory drafts don't embed images, and an <img>
  // src is an external-fetch / tracking-pixel vector once a draft is shared.
  FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'img', 'form', 'input', 'link', 'base'],
  FORBID_ATTR: [
    'onerror', 'onload', 'onclick', 'onmouseover', 'onmouseout',
    'onfocus', 'onblur', 'onchange', 'onsubmit', 'onkeydown', 'onkeyup',
  ],
};

/**
 * Sanitize an HTML string for safe injection via dangerouslySetInnerHTML.
 * @param {string} html
 * @returns {string} sanitized HTML
 */
export function sanitizeDocHtml(html) {
  return DOMPurify.sanitize(String(html || ''), CONFIG);
}

export default sanitizeDocHtml;
